"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupEditable = void 0;
const PopupEditable_1 = __importDefault(require("./PopupEditable"));
exports.PopupEditable = PopupEditable_1.default;
exports.default = PopupEditable_1.default;
